import React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';

function Star({ color = colors.actionMinor[500], ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path
                d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                fill={color}
                fillRule="evenodd"
            />
        </svg>
    );
}

export default Star;
